import * as React from 'react';
import { styled } from '@mui/material/styles';
import { CircularProgress, LinearProgress } from '@mui/material';

export type Props = {
	fullHeight?: boolean;
	linear?: boolean;
	message?: string;
};

export const WrapperCommon = styled('div')`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	flex: 1;
	flex-direction: column;
	line-height: 5;
`;

export const LoadingWrapper = styled(WrapperCommon)``;

export const FullLoadingWrapper = styled(WrapperCommon)`
	min-height: 100vh;
`;

export const LoadingLayout = (props: Props) => {
	const render = () => {
		const Wrapper = props.fullHeight ? FullLoadingWrapper : LoadingWrapper;
		const progressJSX = props.linear ? <LinearProgress style={{ width: '100%' }} /> : <CircularProgress />;
		const returnValue = (
			<Wrapper>
				{progressJSX}
				{props.message}
			</Wrapper>
		);
		return returnValue;
	};
	const outerReturnValue = render();
	return outerReturnValue;
};
